import React from 'react'
import PropTypes from 'prop-types'

import { Input, Form } from 'semantic-ui-react'

const FormInputText = props => {
  const { autoFocus, fluid, icon, name, noLabel, text, type } = props

  return (
    <Form.Field>
      {noLabel ? '' : <label>{text}</label>}
      <Input
        autoFocus={autoFocus}
        fluid={fluid}
        icon={icon}
        iconPosition="left"
        name={name}
        onChange={props.onChange}
        placeholder={text}
        type={type}
        value={props.value}
      />
    </Form.Field>
  )
}

FormInputText.propTypes = {
  autoFocus: PropTypes.bool,
  fluid: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  noLabel: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
}

FormInputText.defaultProps = {
  autoFocus: false,
  fluid: false,
  noLabel: false,
  type: '',
}

export default FormInputText
